<template>
  <div v-if="mode">
    <comment :element-uuid="element.uuid" :submission-uuid="main_sid" />
    <md-field v-if="saveData.label" class="no-line" :class="messageClass">
      <!--<label>{{ saveData.label | token_replace(nid)}}</label>-->
      <span class="md-error">*Required.</span>
    </md-field>
    <div class="h5p-iframe-wrapper">

      <iframe v-if="content_id"
        :id="'h5p-iframe-' + content_id"
        class="h5p-iframe"
        :data-content-id="content_id"
        frameborder="0"
        scrolling="no"
        ref="iframe"
        :title="saveData.label != '' ? saveData.label : saveData.node_name"
      ></iframe>
    </div>
  </div>
  <md-card v-else class="md-elevation-2 md-layout-item">
    <fb-controll
      :controll="saveData.label || 'H5P'"
      @collapse-click="collapsePreview"
      @setting-click="showSettings"
      @menu-delete="$emit('menu-delete')"
    />
    <md-content v-show="!collapse">
      <h2>H5P: {{saveData.value.name | token_replace(nid)}}</h2>
    </md-content>
    <md-dialog :md-active.sync="showDialog" md-dynamic-height>
      <md-dialog-title>Settings</md-dialog-title>
      <md-dialog-content>
        <md-field>
          <label>Label</label>
          <md-input v-model="tempData.label"></md-input>
        </md-field>
        <md-autocomplete
          :value="tempData.node_name"
          md-value-key="value"
          :md-options="node_list"
          @md-changed="getNodes"
          @md-opened="getNodes"
          @md-selected="setH5P"
        >
          <label>H5P Content</label>
          <template slot="md-autocomplete-item" slot-scope="{ item }">{{ item.name }}</template>
        </md-autocomplete>
        <md-checkbox v-model="tempData.required">Required</md-checkbox><br/>
        <md-checkbox v-model="tempData.include_submission">Include on submission view and download</md-checkbox>
        <p><a target="_blank" href="/node/add/h5p">Create H5P</a></p>
      </md-dialog-content>
      <md-dialog-actions>
        <md-button class="md-primary" @click="cancel">Close</md-button>
        <md-button class="md-primary" @click="save">Save</md-button>
      </md-dialog-actions>
    </md-dialog>
  </md-card>
</template>

<script>
import FbElementMixin from "../FbElementMixin";
import HelpersMixin from '../../../HelpersMixin';

export default {
  name: "FbHtmlPackage",
  props: ["element", "mode", "validate", "step", "active"],
  mixins: [FbElementMixin, HelpersMixin],
  created() {
    if (
      this.sid &&
      this.sid != "" &&
      window.drupalSettings.form_builder[this.nid]["submissions"][this.sid][
        this.element.uuid
      ]
    ) {
      this.saveData.result =
        window.drupalSettings.form_builder[this.nid]["submissions"][this.sid][
          this.element.uuid
        ].value;
      this.$emit("set-value", this.value);
    }
    this.$emit("validation", this.valid);
  },
  computed: {
    messageClass() {
      return {
        "hidden": !this.validate,
        "md-invalid": !this.valid && this.validate === true
      };
    },
    valid() {
      let lib = this.element.data.content_library ? this.element.data.content_library.name : '';
      if (this.isDraft) {
        return true;
      }
      if (
        (this.saveData.required === false && this.step == this.active) ||
        (this.saveData.required === false && this.viewed)
      ) {
        return true;
      }
      if (this.saveData.required === false) {
        return true;
      }

      if (this.saveData.required === true && lib == "H5P.QuestionSet") {
        return (
          this.saveData.result.completion === true &&
          this.saveData.result.success === true
        );
      }
      return (
        this.saveData.required === true &&
        this.saveData.result.completion === true
      );
    },
    value() {
      if (this.valid) {
        return {
          uuid: this.element.uuid,
          label: this.saveData.label,
          value: this.saveData.result,
          type: this.element.type
        };
      }
      return undefined;
    }
  },
  mounted: function() {
    this.init();
    // Stop everything except the current page with initial loading.
    window.document.querySelectorAll('.h5p-iframe').forEach(el => {
      el.addEventListener('load', () => {
        let active = el.closest('.md-stepper-content.md-active');
        let step = this.step;
        if (active) {
          step = active.closest('.md-stepper').getAttribute('uuid');
        }
        if (step && step != this.active && el.contentWindow && el.contentWindow.H5P && el.contentWindow.H5P.instances[0]) {
          let machineName = el.contentWindow.H5P.instances[0].libraryInfo.machineName;
          let instance = el.contentWindow.H5P.instances[0];
          if (machineName == 'H5P.Audio' && !instance.audio.paused) {
            instance.pause();
          }
          if (machineName == 'H5P.InteractiveVideo') {
            instance.pause();
          }
        }
      });
    });
  },
  activated: function() {
    this.init();
  },
  data() {
    return {
      node_list_ext: [],
      node_list: [],
      viewed: false,
      content_id: this.element.data.content_id,
      tempData: {
        node_name:
          this.element && this.element.data ? this.element.data.node_name : "",
        label: this.element && this.element.data ? this.element.data.label : "",
        value: this.element && this.element.data ? this.element.data.value : {},
        result: {},
        required:
          this.element && this.element.data
            ? !!this.element.data.required
            : false,
        include_submission:
          this.element && this.element.data
            ? !!this.element.data.include_submission
            : false
      },
      saveData: {
        node_name:
          this.element && this.element.data ? this.element.data.node_name : "",
        label: this.element && this.element.data ? this.element.data.label : "",
        value: this.element && this.element.data ? this.element.data.value : {},
        result: {},
        required:
          this.element && this.element.data
            ? !!this.element.data.required
            : false,
        include_submission:
          this.element && this.element.data
            ? !!this.element.data.include_submission
            : false
      }
    };
  },
  methods: {
    init() {
      if (this.$refs.iframe) {
        this.$refs.iframe.classList.remove("h5p-initialized");
      }

      let self = this;
      if (this.step == this.active) {
        self.viewed = true;
        self.$emit("validation", self.valid);
        self.$emit("set-value", self.value);
      }
      if (typeof H5P != "undefined") {
        try {
          window.H5P.init();
          window.dispatchEvent(new Event("resize"));
        } catch (e) {}
        window.H5P.externalDispatcher.on("xAPI", function(event) {
          if (
            this.contentId == self.element.data.content_id &&
            event.data.statement.hasOwnProperty("result")
          ) {
            let video_summary = false;
            if (
              event.getVerb() === 'answered' &&
              this.parent && this.parent.libraryInfo.machineName == 'H5P.InteractiveVideo' &&
              this.libraryInfo.machineName == 'H5P.Summary' &&
              event.data.statement.result.completion && event.data.statement.result.completion == true
            ) {
              video_summary = true;
            }

            if (
              (event.getVerb() === 'completed' || event.getVerb() === 'answered') && !event.getVerifiedStatementValue(['context', 'contextActivities', 'parent']) ||
              video_summary
            ) {
              self.saveData.result = event.data.statement.result;
              self.$emit("validation", self.valid);
              self.$emit("set-value", self.value);
            }
          }
        });
      }
    },
    getNodes(searchTitle) {
      this.node_list = new Promise(resolve => {
        if (!searchTitle) {
          resolve(this.node_list_ext);
          return;
        }
        const node = searchTitle.toLowerCase();
        const content_manager_groups = drupalSettings.user.content_manager_groups;

        let requestUri = "/jsonapi/node/h5p?filter[title][condition][path]=title&filter[title][condition][value]=" +
          node +
          "&filter[title][condition][operator]=CONTAINS";
        if (this.isAdministrator() != true) {
          if (content_manager_groups && Object.keys(content_manager_groups).length) {
            requestUri += '&filter[field_group_user][group][conjunction]=OR';
            requestUri += '&filter[field_group][condition][path]=field_group.id&';
            Object.keys(content_manager_groups).forEach((value, index) => {
              requestUri += '&filter[field_group][condition][value][' +index +']=' + value;
            });
            requestUri += '&filter[field_group][condition][operator]=IN';
            requestUri += '&filter[field_group][condition][memberOf]=field_group_user';
            requestUri += "&filter[uid][condition][path]=uid.id";
            requestUri += "&filter[uid][condition][value]=" + window.drupalSettings.user.uuid;
            requestUri += "&filter[uid][condition][memberOf]=field_group_user";
          }
          else {
            requestUri += "&filter[uid.id][value]=" + window.drupalSettings.user.uuid;
          }
        }

        fetch(requestUri)
          .then(res => {
            return res.json();
          })
          .then(json => {
            let res = json.data.map(el => {
              return {
                id: el.attributes.drupal_internal__nid,
                name: el.attributes.title
              };
            });
            let filtered = res.filter(({ name }) => {
              return name.toLowerCase().includes(node);
            });
            this.node_list_ext = filtered;
            resolve(filtered);
          })
          .catch(() => {
            resolve(this.node_list_ext);
          });
      });
    },
    setH5P(event) {
      this.tempData.node_name = event.name;
      this.tempData.value = event;
    },
    updateH5P(h5p) {
      this.saveData.value = h5p;
      this.$emit("validation", this.valid);
    }
  },
  watch: {
    active(val) {
      if (this.viewed === false && val == this.step) {
        this.viewed = true;
      }
      window.document.querySelectorAll('.h5p-iframe').forEach(el => {
        if (this.step != this.active && el.contentWindow && el.contentWindow.H5P && el.contentWindow.H5P.instances[0]) {
          let machineName = el.contentWindow.H5P.instances[0].libraryInfo.machineName;
          let instance = el.contentWindow.H5P.instances[0];
          if (machineName == 'H5P.Audio' && !instance.audio.paused) {
            instance.pause();
          }
          if (machineName == 'H5P.InteractiveVideo') {
            instance.pause();
          }
        }
      });
      this.$emit("validation", this.valid);
    },
    valid(val) {
      if (val == true) {
        this.$emit("set-value", this.value);
      }
    }
  }
};
</script>

<style scoped>
.md-field.no-line.md-theme-default.md-invalid:after,
.md-field.no-line.md-theme-default:after {
  background-color: transparent;
}
.md-dialog-content::-webkit-scrollbar {
  -webkit-appearance: none;
  width: 7px;
}

.md-dialog-content::-webkit-scrollbar-thumb {
  border-radius: 4px;
  background-color: rgba(0, 0, 0, 0.5);
  box-shadow: 0 0 1px rgba(255, 255, 255, 0.5);
}
</style>
